import type { z } from 'zod'

import type { getRental_rental } from 'Constants/graphql/queries/detail/__generated__/getRental'

import type { cancelDeviceModalFormSchema } from './CancelDeviceModal.schema'

export interface CancelDeviceModalProps {
  handleModalSubmit: () => void
  isScheduledCancellationEnabled: boolean
  onClose: () => void
  rental: getRental_rental
}

export type CancelDeviceModalFormSchema = z.infer<
  typeof cancelDeviceModalFormSchema
>

export enum CancellationTypeEnum {
  IMMEDIATE = 'immediate',
  SCHEDULED = 'scheduled',
}
